import { translate } from '@/domains/core/localization/translate';
export const sortTranslations = translate({
  "title": "Sort by",
  "relevance": "Relevance",
  "price.asc": "Price low to high",
  "price.desc": "Price high to low",
  "rating.desc": "Highest ratings"
});